export default __webpack_public_path__ + "static/blob2-ffe57a074a436b1a3a3da2c4a5c58b94.png";